import IPagination from 'interfaces/Pagination';
import IClaimDetails from 'models/ClaimDetails';
import IIntervention, { IInterventionCount } from 'models/Intervention';
import IInterventionDetails, {
  IInterventionTimeline,
} from 'models/InterventionDetails';
import IInterventionDocuments from 'models/InterventionDocuments';
import IInterventionSearched from 'models/InterventionSearched';
import IInterventionStatusDateChanged from 'models/InterventionStatusChangedDate';
import IInterventionThread from 'models/InterventionThread';

export interface IInterventionData {
  addDocument: {
    config: {
      isLoading: boolean;
    };
  };
  addNote: {
    config: {
      isLoading: boolean;
    };
  };
  addWorker: {
    config: {
      isLoading: boolean;
    };
  };
  archiveThreadMessage: {
    config: {
      isLoading: boolean;
    };
  };
  createThread: {
    config: {
      isLoading: boolean;
    };
  };
  createThreadMessage: {
    config: {
      isLoading: boolean;
    };
  };
  deleteDocument: {
    config: {
      isLoading: boolean;
    };
  };
  edit: {
    config: {
      isLoading: boolean;
    };
  };
  getAll: {
    config: {
      count: IInterventionCount;
      emptyMsg: string;
      errorMsg: string;
      filters: {
        custom?: string[];
        interventionType?: string[];
        status?: string[];
      };
      isLoading: boolean;
      pagination: IPagination;
    };
    list: IIntervention[];
  };
  getAllThreads: {
    config: {
      emptyMessage: string;
      errorMessage: string;
      isLoading: boolean;
    };
    list: IInterventionThread[];
  };
  getDetails: {
    activeTimelineActionIndex: number;
    claimInfo: IClaimDetails | null;
    config: {
      isLoading: boolean;
    };
    timeline: IInterventionTimeline[];
    values: IInterventionDetails | null;
  };
  getDocuments: {
    availableDocuments: string[];
    config: {
      isLoading: boolean;
    };
    documents: {
      invoice: IInterventionDocuments[];
      mandate: IInterventionDocuments[];
      photosDamage: IInterventionDocuments[];
      photosRepair: IInterventionDocuments[];
      report: IInterventionDocuments[];
    };
  };
  getSearchedIntervention: {
    config: {
      emptyMsg: string;
      errorMsg: string;
      isLoading: boolean;
    };
    list: IInterventionSearched[];
  };
  getStatusDateChanged: {
    config: {
      isLoading: boolean;
    };
    values: IInterventionStatusDateChanged[];
  };
  markThreadMessageAsOpen: {
    config: {
      isLoading: boolean;
    };
  };
  removeWorker: {
    config: {
      isLoading: boolean;
    };
  };
  updateNote: {
    config: {
      isLoading: boolean;
    };
  };
}

const interventionInitialState: IInterventionData = {
  edit: {
    config: {
      isLoading: false,
    },
  },
  addDocument: {
    config: {
      isLoading: false,
    },
  },
  addWorker: {
    config: {
      isLoading: false,
    },
  },
  removeWorker: {
    config: {
      isLoading: false,
    },
  },
  deleteDocument: {
    config: {
      isLoading: false,
    },
  },
  getAll: {
    config: {
      isLoading: false,
      emptyMsg: '',
      errorMsg: '',
      count: {
        complaint_count: 0,
        date_inspection_required_count: 0,
        date_repair_intervention_required_count: 0,
        expertise_count: 0,
        expertise_date_required_count: 0,
        info_client_needed_count: 0,
        info_insurer_needed_count: 0,
        info_pro_needed_count: 0,
        inspection_planned_count: 0,
        leak_detection_date_required_count: 0,
        leak_detection_planned_count: 0,
        no_cost_count: 0,
        paid_count: 0,
        urgent_repair_intervention_planned_count: 0,
        cost_repair_intervention_planned_count: 0,
        quote_repair_intervention_planned_count: 0,
        urgent_date_repair_intervention_required_count: 0,
        cost_plus_date_repair_intervention_required_count: 0,
        quote_date_repair_intervention_required_count: 0,
        new_messages: 0,
        process_invoice_count: 0,
        process_leak_detection_report_count: 0,
        quality_issue_count: 0,
        quote_evaluation_count: 0,
        repair_intervention_planned_count: 0,
        trashed_count: 0,
        waiting_for_invoice_count: 0,
        waiting_for_leak_detection_report_count: 0,
        waiting_for_quote_count: 0,
      },
      filters: {
        custom: [],
        interventionType: [],
        status: [],
      },
      pagination: {
        page: 1,
        totalPages: 1,
      },
    },
    list: [],
  },
  getDetails: {
    config: {
      isLoading: false,
    },
    values: null,
    claimInfo: null,
    activeTimelineActionIndex: 0,
    timeline: [],
  },
  getDocuments: {
    availableDocuments: [],
    config: {
      isLoading: false,
    },
    documents: {
      invoice: [],
      mandate: [],
      photosDamage: [],
      photosRepair: [],
      report: [],
    },
  },
  getStatusDateChanged: {
    config: {
      isLoading: false,
    },
    values: [],
  },
  getSearchedIntervention: {
    config: {
      emptyMsg: '',
      errorMsg: '',
      isLoading: false,
    },
    list: [],
  },
  createThread: {
    config: {
      isLoading: false,
    },
  },
  createThreadMessage: {
    config: {
      isLoading: false,
    },
  },
  archiveThreadMessage: {
    config: {
      isLoading: false,
    },
  },
  markThreadMessageAsOpen: {
    config: {
      isLoading: false,
    },
  },
  getAllThreads: {
    list: [],
    config: {
      isLoading: false,
      errorMessage: '',
      emptyMessage: '',
    },
  },
  addNote: {
    config: {
      isLoading: false,
    },
  },
  updateNote: {
    config: {
      isLoading: false,
    },
  },
};

export default interventionInitialState;
